import { axios, API } from "@/imports-files/common/common";
import { SendRequest } from "@/imports-files/pages/admins/logout";

export class ScorecardImportService extends SendRequest
{
  async templatelist(params)
  {
    const url = API.client.scorecard_templates.TEMPLATE_LIST;
    try {
      const result = await axios.get( url,
      {
        params: params,
        headers: this.customHeaderJSON()
      },
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async importScorecard(job_id, template_id){
    const url = API.client.jobs.IMPORT_SCORECARD.replace('$job_id', job_id);
    try {
      const result = await axios.get( url,
      {
        params: {template_id: template_id},
        headers: this.customHeaderJSON()
      },
      this.setHeaderJSON(),
      this.setCrossDomainTrue(),
      this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }
}